import * as React from "react";
import {
  Box
} from "@chakra-ui/react";


interface Props {
  children: React.ReactNode
  background?: object | string | undefined
  padding?: object | string | undefined
}


export const SectionWrapper: React.FC<Props> = ( props ) => {
  return (
    <Box
      as="section"
      position="relative"
      w="100%"
      background={ props.background }
      padding={ props.padding }
    >
      { props.children }
    </Box>
  )
}
